import { objectToCamelCase, objectToSnakeCase } from '../utils'
import UserAPI from './api'

export default class User {
  static api = UserAPI.create(User)

  constructor(user) {
    user = user || {}

    const {
      id = '',
      firstName = '',
      lastName = '',
      email = '',
      fullName = '',
      paypalEmail = '',
      birthYear = null,
      zipCode = null,
      isEmployee = null,
      isAdmin = null,
      isStaff = null,
      isThirdParty = null,
      preferredLanguage = 'en',
    } = user
    Object.assign(this, {
      id,
      firstName,
      lastName,
      email,
      fullName,
      paypalEmail,
      birthYear,
      zipCode,
      isEmployee,
      isAdmin,
      isStaff,
      isThirdParty,
      preferredLanguage,
    })
  }

  static create(opts) {
    return new User(opts)
  }

  static fromAPI(json) {
    return new User(objectToCamelCase(json))
  }

  static toAPI(json) {
    const data = objectToSnakeCase(json)
    return data
  }

  clone() {
    return new User(this)
  }

  /* Validate a user email meets the following format: anystring@anystring.anystring */
  static validateEmail(email) {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }
}
